<template>
  <TarjetaDatos titulo="Capitales">
    <Campo2L
      :valor="poliza.calidadConstruccion"
      etiqueta="Calidad Construccion"
    />
    <Campo2L :valor="poliza.contenido | currencyEUR" etiqueta="Contenido" />
    <Campo2L :valor="poliza.continente | currencyEUR" etiqueta="Continente" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
